import { render, staticRenderFns } from "./KnowledgeBaseQuery.vue?vue&type=template&id=321927da&scoped=true"
import script from "./KnowledgeBaseQuery.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseQuery.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeBaseQuery.vue?vue&type=style&index=0&id=321927da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321927da",
  null
  
)

export default component.exports